<script setup>
  import { computed, onMounted } from "vue";
  import { useRoute } from "vue-router";

  import BaseHeader from "./BaseHeader.vue";
  import WorkspaceLnb from "./WorkspaceLnb.vue";
  import { useWorkspaceStore } from "@/stores/workspace";

  // 나의 검사 관리 업무 화면 공통 틀 (US-4000): 업무용 헤더 + LNB + 콘텐츠 (푸터 없음) — 학생 화면은 LNB 없이
  const ws = useWorkspaceStore();
  const route = useRoute();

  // 헤더 1행 68px + 2행 48px(+경계 1px). 배정 시험이 1개이거나 상단 메뉴 화면이면 2행을 숨긴다
  //  콘텐츠 크게 보기(ws.contentZoom)면 헤더 · LNB 를 접는다
  const headerHeight = computed(() => {
    if (ws.contentZoom) return "0px";
    return ws.assignedExams.length > 1 && !route.meta.wsTopMenu ? "117px" : "68px";
  });

  onMounted(() => {
    ws.fetchRounds();
  });
</script>

<template>
  <div class="ws-layout" :class="{ 'is-zoom': ws.contentZoom }" :style="{ '--ws-header-h': headerHeight }">
    <BaseHeader variant="workspace" />
    <div class="ws-shell">
      <!-- 헤더 상단 메뉴 화면(구성원 관리)은 시험과 무관해, 학생 화면은 업무 메뉴가 없어 LNB 없음 -->
      <WorkspaceLnb v-if="!route.meta.wsTopMenu && !route.meta.wsNoLnb" />
      <main class="ws-main" :class="{ 'is-centered': route.meta.wsTopMenu }">
        <router-view />
      </main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .ws-layout {
    min-width: var(--smoe-content-w);
    min-height: 100vh;
    padding-top: var(--ws-header-h);
    background: #f5f7fa;
  }

  .ws-shell {
    display: flex;
    min-height: calc(100vh - var(--ws-header-h));
  }

  // 본문 좌우 여백은 --ws-main-px 로 노출 (상세 하단 고정 바가 여백만큼 바깥으로 붙는다)
  .ws-main {
    --ws-main-px: 32px;
    flex: 1;
    min-width: 0;
    padding: 24px var(--ws-main-px) 80px;
  }

  // 상단 메뉴 화면(구성원 관리): LNB 가 없으므로 기술지원 화면처럼 콘텐츠를 가운데 1232px 로
  .ws-main.is-centered > :deep(*) {
    max-width: 1232px;
    margin-right: auto;
    margin-left: auto;
  }

  // 콘텐츠 크게 보기: 헤더 · LNB 숨김 (두 컴포넌트 모두 루트가 여러 개라 v-show 대신 클래스로)
  .ws-layout.is-zoom {
    :deep(.nh),
    :deep(.ws-lnb) {
      display: none;
    }
  }

  .ws-layout.is-zoom .ws-main {
    --ws-main-px: 28px;
    padding-top: 20px;
  }
</style>
